exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("./ciq_bg.jpg"));

// Module
exports.push([module.id, "._3ZnszAjV3oW5Ip5U8CH-5l{background:url(" + ___CSS_LOADER_URL___0___ + ") center/cover;min-height:calc(100vh - 60px);padding:5vh 0}._3ZnszAjV3oW5Ip5U8CH-5l .OMPWQaK1pcf5XRF7KG0w-{text-align:center}._3ZnszAjV3oW5Ip5U8CH-5l p{margin-bottom:20px}.y1X8ORdpRMPu0Gx4IWHKV{width:410px;max-width:96%;margin:0 auto}._1SU83y-DetpvMzKRJPC05X{max-width:410px;margin:0 auto}._2lDh_X4jr_DBHQs3NAlvQy{color:#d20007}\n", ""]);

// Exports
exports.locals = {
	"PairDevicePage": "_3ZnszAjV3oW5Ip5U8CH-5l",
	"container": "OMPWQaK1pcf5XRF7KG0w-",
	"Modal": "y1X8ORdpRMPu0Gx4IWHKV",
	"Login": "_1SU83y-DetpvMzKRJPC05X",
	"error": "_2lDh_X4jr_DBHQs3NAlvQy"
};